<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import { FileUtils } from '@/common/utils'
import { PhotographyContributionDetail, SupplementaryContractDialog } from '@/components/widgets'

export default {
    components: {
        WPhotographyContributionDetail: PhotographyContributionDetail,
        WSupplementaryContractDialog: SupplementaryContractDialog
    },
    props: {
        value: Boolean,
        params: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            info: {},
            activeName: 'works',
            showSupplementaryContractDialog: false,

            detailDrawer: false
        };
    },
    methods: {
        init() {
            this.getPhotoworkDetail()
        },
        async getPhotoworkDetail() {
            let { type } = this.params
            let apiName = 'getPhotoworkDetail'

            if(type === 9) {
                apiName = 'getContributionDetail'
            }

            this.info = await this.api[apiName](this.params)
        },
        // 绑定合同对话框关闭
        supplementaryContractDialogClose() {
            // 刷新详情组件合同数据
            if(this.$refs.detail.getPhotoworkContractList) {
                this.$refs.detail.getPhotoworkContractList()
            }
        },
        userDetailClick() {
            let location = this.$router.resolve({ path: '/userManager/userBaseInfo/userBaseInfoDetail', query: { open_id: this.info.openId } })
            window.open(location.href)
        },
        // 单文件下载
        async download() {
            let { url, fileUrl, midIdName, fileName } = this.info

            const fileUtils = new FileUtils(url || fileUrl, midIdName || fileName)
            await fileUtils.readUrl()
            await fileUtils.download()
        },
        operationSuccess() {
            this.closeDrawer()
        },
        closeDrawer() {
            this.$emit('input', false)
        }
    },
    watch: {
        value(val) {
            this.detailDrawer = val

            if(val) {
                this.init()
            }
        }
    }
};
</script>
